<template>
  <div class="about">
    <Titulo texto="Pagina de Quienes Somos" />
  </div>
</template>

<script>
import Titulo from '@/components/Titulo.vue'

export default {
  name: 'About',
  components: {
    Titulo
  }
}
</script>
